import utilDebounce  from '../../utils/debounce'
// import Cookies from 'js-cookie'

const debounce = utilDebounce.debounce;
// const LocalUserData = nativeConfig.mockUser;

class TokenServer {
  constructor () {
    // token 值
    this.token = ''
    // 刷新计数器
    this.refreshTimer = null
    // 刷新间隔时间
    this.refreshInterval = 0
    // 防抖 refreshToken
    this.refreshToken = debounce(this.refreshToken, 1500, {
      leading: true,
      trailing: false
    }).bind(this)
  }

  // 刷新 token
  async refreshToken (time) {
    // 清除refreshTimer
    if (this.refreshTimer) this.clearRefresh(false)
    // 更新token
    await this.getToken(true)
    // 设置refreshTimer
    if (time) this.refreshInterval = time
    if (this.refreshInterval) {
      this.refreshTimer = setTimeout(
        this.refreshToken,
        this.refreshInterval
      )
    }
  }

  // 清楚刷新
  clearRefresh (never = true) {
    clearTimeout(this.refreshTimer)
    this.refreshTimer = null
    if (never) this.refreshInterval = 0
  }

  // 获取 token
  async getToken (force) {
    let token = this.token
    if (token && !force) return token
    let user = await window.mx.getUser();
    if (!user) throw new Error('TokenServer getToken error: getUser fail')
    token = user.ssoToken || user.accessToken
    await this.setToken(token)
    return token
  }

  // 安卓环境下 cookie 中的 Token 可能不正确, 建议还是通过 getUser 进行获取
  // getTokenByCookie() {
  //   this.token = Cookies.get('token')
  //   return this.token
  // }

  // 设置 token
  async setToken (token) {
    if (!token) throw new Error('TokenServer setToken error: token is null')

    const result = await this.checkToken(token)
    if (!result) throw new Error('TokenServer setToken error: token is error')

    this.token = token
  }

  // 检测 token
  async checkToken () {
    // TODO
    return true
  }
}

export default TokenServer
